import { ca } from '@cian/analytics';

import { TSellerType } from '../NewbuildingCallButton/tracking';

interface ITrackOpenChatContacts {
  newbuildingId: number;
  url: string;
}

export function trackOpenChatContacts({ newbuildingId, url }: ITrackOpenChatContacts) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'open_contacts_chats',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
  });
}

interface ITrackChatEvent {
  newbuildingId: number;
  url: string;
  ownerId: number;
  sellerType?: TSellerType;
}

function makeChatPageExtra({ ownerId, sellerType }: Pick<ITrackChatEvent, 'ownerId' | 'sellerType'>) {
  return {
    extra: {
      type: 'Open_compare_jk_listing',
      owner_id: ownerId,
      ...(sellerType ? { seller_type: sellerType } : {}),
    },
  };
}

export function trackSendMessage({ newbuildingId, url, ownerId, sellerType }: ITrackChatEvent) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'send_message',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: makeChatPageExtra({ ownerId, sellerType }),
  });
}

export function trackOpenMessagePopup({ newbuildingId, url, ownerId, sellerType }: ITrackChatEvent) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: makeChatPageExtra({ ownerId, sellerType }),
  });
}

export interface ITrackOpenChatGallery {
  newbuildingId: number;
  url?: string;
  category: 'CompareJK' | 'Message_popup';
  action: 'open' | 'send_message';
}

export function trackOpenChatGallery({ newbuildingId, url, category, action }: ITrackOpenChatGallery) {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action,
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: 'builders',
        ...(action === 'open' ? { source: 'CompareJK' } : {}),
      },
      siteType: 'desktop',
      pageType: 'ListingCompareJK',
    },
  });
}
